export default __webpack_public_path__ + "static/media/superbonus-pcMockup.8b92f712.png";